import { pxToRem } from '../../../../lib';
import getBorderFocusStyles from '../../getBorderFocusStyles';
var hierarchicalTreeTitleStyles = {
  root: function root(_ref) {
    var variables = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    return Object.assign({
      padding: "".concat(pxToRem(1), " 0"),
      cursor: 'pointer',
      color: variables.defaultColor,
      position: 'relative'
    }, getBorderFocusStyles({
      siteVariables: siteVariables
    }));
  }
};
export default hierarchicalTreeTitleStyles;